export const truncateAddr = (addr) => {
  return addr.slice(0, 6) + "..." + addr.slice(-4);
};
